module.exports = __webpack_public_path__ + "static/img/scene2.3cee8f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene/scene2.png
// module id = j1ol
// module chunks = 1